<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="edit">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <h4 class="modal-title">{{form.modal.title}}</h4>
        </div>
        <div class="modal-body">

          <div class="panel-body">
            <div class="row panel-heading">
              <div class="col-sm-12 text-center">
                <form class="form-inline search-fields" @submit.prevent="form.onSiteSearch('larvalSiteId')">
                  <div class="form-group">
                    <select class="form-control" id="searchField" name="searchField" v-model="form.siteSearch.field">
                      <option value="site">Site</option>
                      <option value="zone">Zone</option>
                      <option value="location">Location</option>
                      <option value="route">Route</option>
                    </select>
                  </div>
                  <div class="input-group">
                    <input type="search" placeholder="search sites" class="form-control" v-model="form.siteSearch.term">
                    <span class="input-group-addon pointer" v-on:click="form.onSiteSearch('larvalSiteId')" title="search"><i class="fa fa-search"></i></span>
                  </div>
                  <i class="fa fa-spinner fa-spin" v-if="siteSearch.loading"></i>
                  <button type="button" class="btn btn-default ml-20" v-if="!siteSearch.loading" v-on:click="newSite">Create new site</button>
                </form>
              </div>
            </div>
          </div>

          <form @submit.prevent="form.onSubmit" @keydown="form.errors.clear($event.target.id)">
            <input type="hidden" name="id" v-model="form.data.id">

            <div class="form-group" :class="{'has-error': form.errors.has('larvalSiteId') }">
              <label class="control-label">Site</label>
              <div class="form-group">
                <select class="form-control" v-model="form.data.larvalSiteId" v-on:change="setSelected">
                  <option v-for="item in siteSearch.sites" v-bind:value="item.id">{{item.attributes.name}}</option>
                </select>
              </div>
              <span class="help-block" v-if="form.errors.has('larvalSiteId')" v-text="form.errors.get('larvalSiteId')"></span>
            </div>

            <div class="site-details">
              <div class="row">
                <div class="col-xs-12 col-sm-4 col-sm-offset-2"><strong>Name:</strong> {{ siteSearch.selected.name }}</div>
                <div class="col-xs-12 col-sm-4"><strong>Address:</strong> {{ siteSearch.selected.address }}, {{ siteSearch.selected.city }}, {{ stateName(siteSearch.selected.stateId) }} {{ siteSearch.selected.zip }}</div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-sm-4 col-sm-offset-2"><strong>Zone:</strong> {{ zoneName(siteSearch.selected.zoneId) }}</div>
                <div class="col-xs-12 col-sm-4"><strong>Route:</strong> {{ routeName(siteSearch.selected.routeId) }}</div>
              </div>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('appliedDate') }">
              <label class="control-label">Date</label>
              <date-picker v-model="form.data.appliedDate"></date-picker>
              <span class="help-block" v-if="form.errors.has('appliedDate')" v-text="form.errors.get('appliedDate')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('appliedTime') }">
              <label class="control-label">Time <span class="optional">(optional)</span></label>
              <masked-input v-model="form.data.appliedTime" mask="11:11" placeholder="HH:MM" class="form-control" />
              <span class="help-block" v-if="form.errors.has('appliedTime')" v-text="form.errors.get('appliedTime')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('applicatorId') }">
              <label class="control-label">Applicator</label>
              <div class="form-group">
                <select class="form-control" v-model="form.data.applicatorId">
                  <option></option>
                  <option v-for="item in applicators" v-bind:value="item.id">{{item.attributes.inspector}}</option>
                </select>
              </div>
              <span class="help-block" v-if="form.errors.has('applicatorId')" v-text="form.errors.get('applicatorId')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('temperature') }">
              <label class="control-label">Temperature <span class="optional">(optional)</span></label>
              <input type="text" class="form-control" id="temperature" v-model="form.data.temperature">
              <span class="help-block" v-if="form.errors.has('temperature')" v-text="form.errors.get('temperature')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('windSpeed') }">
              <label class="control-label">Wind Speed <span class="optional">(optional)</span></label>
              <input type="text" class="form-control" id="windSpeed" v-model="form.data.windSpeed">
              <span class="help-block" v-if="form.errors.has('windSpeed')" v-text="form.errors.get('windSpeed')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('windDirectionId') }">
              <label class="control-label">Wind Direction <span class="optional">(optional)</span></label>
              <div class="form-group">
                <select class="form-control" v-model="form.data.windDirectionId">
                  <option></option>
                  <option v-for="item in windDirections" v-bind:value="item.id">{{item.attributes.direction}}</option>
                </select>
              </div>
              <span class="help-block" v-if="form.errors.has('windDirectionId')" v-text="form.errors.get('windDirectionId')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('equipmentId') }">
              <label class="control-label">Equipment Used <span class="optional">(optional)</span></label>
              <div class="form-group">
                <select class="form-control" v-model="form.data.lequipmentId">
                  <option></option>
                  <option v-for="item in equipment" v-bind:value="item.id">{{item.attributes.kind}}</option>
                </select>
              </div>
              <span class="help-block" v-if="form.errors.has('equipmentId')" v-text="form.errors.get('equipmentId')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('eggs') }">
              <label class="control-label">Eggs <span class="optional">(optional)</span></label>
              <div class="form-group">
                <select class="form-control" v-model="form.data.eggs">
                  <option></option>
                  <option v-for="item in larvaCounts" v-bind:value="item.id">{{item.attributes.count}}</option>
                </select>
              </div>
              <span class="help-block" v-if="form.errors.has('eggs')" v-text="form.errors.get('eggs')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('larvae') }">
              <label class="control-label">Larvae <span class="optional">(optional)</span></label>
              <div class="form-group">
                <select class="form-control" v-model="form.data.larvae">
                  <option></option>
                  <option v-for="item in larvaCounts" v-bind:value="item.id">{{item.attributes.count}}</option>
                </select>
              </div>
              <span class="help-block" v-if="form.errors.has('larvae')" v-text="form.errors.get('larvae')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('pupae') }">
              <label class="control-label">Pupae <span class="optional">(optional)</span></label>
              <div class="form-group">
                <select class="form-control" v-model="form.data.pupae">
                  <option></option>
                  <option v-for="item in larvaCounts" v-bind:value="item.id">{{item.attributes.count}}</option>
                </select>
              </div>
              <span class="help-block" v-if="form.errors.has('pupae')" v-text="form.errors.get('pupae')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('adults') }">
              <label class="control-label">Adults <span class="optional">(optional)</span></label>
              <div class="form-group">
                <select class="form-control" v-model="form.data.adults">
                  <option></option>
                  <option v-for="item in larvaCounts" v-bind:value="item.id">{{item.attributes.count}}</option>
                </select>
              </div>
              <span class="help-block" v-if="form.errors.has('adults')" v-text="form.errors.get('adults')"></span>
            </div>

            <div class="checkbox" :class="{'has-error': form.errors.has('vizualMonitorPerformed') }">
              <label>
                <input type="checkbox" id="vizualMonitorPerformed" v-model="form.data.vizualMonitorPerformed"> Visual Monitoring</label>
              <span class="help-block" v-if="form.errors.has('vizualMonitorPerformed')" v-text="form.errors.get('vizualMonitorPerformed')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('controlActionId') }">
              <label class="control-label">Control Action</label>
              <div class="form-group">
                <select class="form-control" v-model="form.data.controlActionId">
                  <option></option>
                  <option v-for="item in controlActions" v-bind:value="item.id">{{item.attributes.name}}</option>
                </select>
              </div>
              <span class="help-block" v-if="form.errors.has('controlActionId')" v-text="form.errors.get('controlActionId')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('lchemicalId') }">
              <label class="control-label">Chemical <span class="optional">(optional)</span></label>
              <div class="form-group">
                <select class="form-control" v-model="form.data.lchemicalId">
                  <option></option>
                  <option v-for="item in chemicals" v-bind:value="item.id">{{item.attributes.chemName}}</option>
                </select>
              </div>
              <span class="help-block" v-if="form.errors.has('lchemicalId')" v-text="form.errors.get('lchemicalId')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('amount') }">
              <label class="control-label">Amount (oz) <span class="optional">(optional)</span></label>
              <input type="text" class="form-control" id="amount" v-model="form.data.amount">
              <span class="help-block" v-if="form.errors.has('amount')" v-text="form.errors.get('amount')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('applicationRate') }">
              <label class="control-label">Appl. Rate <span class="optional">(optional)</span></label>
              <div class="form-group">
                <select class="form-control" v-model="form.data.applicationRate">
                  <option></option>
                  <option v-for="item in larvalAppRates" v-bind:value="item.id">{{item.attributes.apprate}}</option>
                </select>
              </div>
              <span class="help-block" v-if="form.errors.has('applicationRate')" v-text="form.errors.get('applicationRate')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('areaTreated') }">
              <label class="control-label">Area Treated (sq. ft.) <span class="optional">(optional)</span></label>
              <input type="text" class="form-control" id="areaTreated" v-model="form.data.areaTreated">
              <span class="help-block" v-if="form.errors.has('areaTreated')" v-text="form.errors.get('areaTreated')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('sampleNumber') }">
              <label class="control-label">Sample Number <span class="optional">(optional)</span></label>
              <input type="text" class="form-control" id="sampleNumber" v-model="form.data.sampleNumber">
              <span class="help-block" v-if="form.errors.has('sampleNumber')" v-text="form.errors.get('sampleNumber')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('wetDry') }">
              <label class="control-label">Wet/Dry <span class="optional">(optional)</span></label>
              <div class="form-group">
                <select class="form-control" v-model="form.data.wetDry">
                  <option></option>
                  <option v-for="item in wetDry" v-bind:value="item.id">{{item.name}}</option>
                </select>
              </div>
              <span class="help-block" v-if="form.errors.has('wetDry')" v-text="form.errors.get('wetDry')"></span>
            </div>

            <div class="checkbox" :class="{'has-error': form.errors.has('predators') }">
              <label>
                <input type="checkbox" id="predators" v-model="form.data.predators"> Predators</label>
              <span class="help-block" v-if="form.errors.has('predators')" v-text="form.errors.get('predators')"></span>
            </div>

            <div class="checkbox" :class="{'has-error': form.errors.has('bitingActivity') }">
              <label>
                <input type="checkbox" id="bitingActivity" v-model="form.data.bitingActivity"> Biting Activity</label>
              <span class="help-block" v-if="form.errors.has('bitingActivity')" v-text="form.errors.get('bitingActivity')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('siteConditions') }">
              <label class="control-label">Site Conditions <span class="optional">(optional)</span></label>
              <input type="text" class="form-control" id="siteConditions" v-model="form.data.siteConditions">
              <span class="help-block" v-if="form.errors.has('siteConditions')" v-text="form.errors.get('siteConditions')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('lStages') }">
              <label class="control-label">Larval Stages <span class="optional">(optional)</span></label>
              <input type="text" class="form-control" id="lStages" v-model="form.data.lStages">
              <span class="help-block" v-if="form.errors.has('lStages')" v-text="form.errors.get('lStages')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('percentBreeding') }">
              <label class="control-label">% Breeding <span class="optional">(optional)</span></label>
              <input type="text" class="form-control" id="percentBreeding" v-model="form.data.percentBreeding">
              <span class="help-block" v-if="form.errors.has('percentBreeding')" v-text="form.errors.get('percentBreeding')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('percentCulex') }">
              <label class="control-label">% Culex <span class="optional">(optional)</span></label>
              <input type="text" class="form-control" id="percentCulex" v-model="form.data.percentCulex">
              <span class="help-block" v-if="form.errors.has('percentCulex')" v-text="form.errors.get('percentCulex')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('percentNonCulex') }">
              <label class="control-label">% Non Culex <span class="optional">(optional)</span></label>
              <input type="text" class="form-control" id="percentNonCulex" v-model="form.data.percentNonCulex">
              <span class="help-block" v-if="form.errors.has('percentNonCulex')" v-text="form.errors.get('percentNonCulex')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('workStatus') }">
              <label class="control-label">Work Status</label>
              <select class="form-control" v-model="form.data.workStatus">
                <option v-for="item in workStatus">{{item}}</option>
              </select>
              <span class="help-block" v-if="form.errors.has('workStatus')" v-text="form.errors.get('workStatus')"></span>
            </div>

            <loading-button :loading="form.loading" class="btn btn-primary" :disabled="form.errors.any()">Save</loading-button>
            <button type="button" class="btn btn-default" data-dismiss="modal">cancel</button>
          </form>
        </div>
        <div class="modal-footer">
        </div>
      </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
  </div><!-- /.modal -->
</template>

<script>
  import LoadingButton from '@/components/loading-button';
  import DatePicker from '@/components/date-picker';
  import MaskedInput from 'vue-masked-input';

  export default {
    name: 'larval-identification-form',

    props: ['form'],

    data() {
      return {
        siteSearch: this.$store.getters.siteSearch
      }
    },

    components: {
      LoadingButton,
      DatePicker,
      MaskedInput,
    },

    methods: {
      zoneName(id) {
        return this.$store.getters.zoneNameById(id);
      },
      routeName(id) {
        return this.$store.getters.routeNameById(id);
      },
      stateName(id) {
        return this.$store.getters.stateNameById(id);
      },
      setSelected() {
        this.$store.dispatch('setSiteSearchSelected', this.form.data.larvalSiteId);
      },
      newSite() {
        this.form.hideEdit();
        this.$router.push({name: 'data-sites-new'})
      }
    },

    computed: {
      applicators() {
        return this.$store.getters.applicators;
      },
      windDirections() {
        return this.$store.getters.windDirections;
      },
      equipment() {
        return this.$store.getters.lEquipment;
      },
      monitors() {
        return this.$store.getters.vizualMonitors;
      },
      controlActions() {
        return this.$store.getters.controlActions;
      },
      chemicals() {
        return this.$store.getters.lChemicals;
      },
      wetDry() {
        return [
          {id: 'wet', name: 'Wet'},
          {id: 'dry', name: 'Dry'},
        ]
      },
      workStatus() {
        return this.$store.getters.workStatus;
      },
      larvaCounts() {
        return this.$store.getters.larvaCounts;
      },
      larvalAppRates() {
        return this.$store.getters.larvalAppRates;
      }
    },


  }

</script>